import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ErrorManagement } from '@printdeal/error-management/react';
import { AnonymousTokenNotAllowedError } from '../errors/AnonymousTokenNotAllowedError';
import { ServiceFactory } from '../services/ServiceFactory';

const useMandate = (orderId: string, mandateId: string) => {
  const { data, status, error } = useQuery({
    queryKey: ['order', 'get-mandate', orderId, mandateId],
    queryFn: async () => ServiceFactory.createPaymentV2Service().getMandate(mandateId),
  });

  useEffect(() => {
    if (status === 'error' && !(error instanceof AnonymousTokenNotAllowedError)) {
      ErrorManagement.exception({
        exception: error,
        extra: { orderId, mandateId },
        tags: {
          fileLocation: 'useMandate',
          featureFunction: 'useMandate',
        },
        fingerprint: ['hooks-use-mandate'],
      });
    }
  }, [error, mandateId, orderId, status]);

  return {
    data,
    status,
  };
};

export default useMandate;
